/**
 * @note
 * This is the full list of menu items for both menu and desktop.
 *
 * Set either `mobileOnly` or `desktopOnly` to `true` to make it exclusive
 * to either one category (tablet devices are considered mobile). You can
 * also apply this to submenu items.
 *
 */
export const MENU_ITEMS = [
	{
		label: "Home",
		link: "/",
		icon: "home.svg",
		isNew: false,
		mobileOnly: true,
		useRouter: true,
	},
	{
		label: "Words With Friends <span class='sub-label'>Cheat</span>",
		link: "/words-with-friends-cheat/",
		title: "Words With Friends Cheat",
		icon: "wwf.svg",
		isNew: false,
		useRouter: true,
	},
	{
		label: "Scrabble <span class='sub-label'>Helpers</span>",
		link: null,
		title: "Scrabble Helpers",
		icon: "scrabble.svg",
		cssClass: "has-hint",
		navLink: true,
		submenuIsOpen: false,
		submenu: [
			{
				sectionName: "Scrabble Helpers",
				desktopOnly: true,
				sectionEntries: [
					{
						label: "Scrabble Dictionary Checker",
						link: "/scrabble-dictionary/",
					},
					{
						label: "Scrabble Cheat",
						link: "/scrabble-cheat/",
					},
					{
						label: "Scrabble Word Finder",
						link: "/",
					},
					{
						label: "Scrabble Word Checker",
						link: "/scrabble-checker/",
					},
				],
			},
		],
	},
	{
		label: "Today's NYT Games <span class='sub-label'>Hints & Answers</span>",
		link: null,
		title: "Today's NYT Games Hints & Answers",
		icon: "calendar.svg",
		cssClass: "has-hint",
		navLink: true,
		submenuIsOpen: false,
		submenu: [
			{
				sectionName: "Wordle",
				sectionEntries: [
					{
						label: "Wordle Solver",
						link: "/wordle/",
						isHot: true,
					},
					{
						label: "Today's Wordle Hints & Answer",
						link: "/wordle/hints/",
					},
					{
						label: "List of Wordle Answers",
						link: "/wordle/answers/",
					},
					{
						label: "Wordle Word Lists",
						link: "/wordle/word-lists/",
					},
					{
						label: "Yesterday's Wordle Hints & Answer",
						link: "/wordle/yesterday-hints/",
					},
				],
			},
			{
				sectionName: "Today's NYT Connections",
				sectionEntries: [
					{
						label: "NYT Connections Hints",
						link: "/nyt-connections/",
					},
					{
						label: "NYT Connections Answers",
						link: "/nyt-connections/todays-answers/",
					},
					{
						label: "Yesterday's NYT Connections Hints & Answer",
						link: "/nyt-connections/yesterday-hints/",
					},
				],
			},
			{
				sectionName: "Today’s NYT Daily Games",
				sectionEntries: [
					{
						label: "NYT Crosswords Clues & Answers",
						link: "/crosswords/new-york-times-crossword/",
					},
					{
						label: "NYT Strands Hints & Answer",
						link: "/nyt-strands/",
					},
					{
						label: "NYT Spelling Bee Answers",
						link: "/nyt-spelling-bee/",
					},
					{
						label: "NYT Crossplay Cheat",
						link: "/nyt-crossplay/",
						isNew: true,
					},
					{
						label: "All NYT Daily Games Helpers",
						link: "/nyt-games/",
					},
				],
			},
		],
	},
	{
		label: "Word Games <span class='sub-label'>Helpers</span>",
		link: null,
		title: "Word Games Helpers",
		icon: "helpers.svg",
		cssClass: "has-hint",
		navLink: true,
		submenuIsOpen: false,
		submenu: [
			{
				sectionName: "Word Tools",
				sectionEntries: [
					{
						label: "Word Unscrambler",
						link: "/unscramble/",
					},
					{
						label: "Anagram Solver",
						link: "/anagram-solver/",
					},
					{
						label: "Word Scramble",
						link: "/word-scramble/",
					},
					{
						label: "Word Maker",
						link: "/word-maker/",
					},
					{
						label: "Random Word Generator",
						link: "/random-word-generator/",
					},
					{
						label: "Words with Letters and a Blank",
						link: "/words-with-letters-blank/",
					},
				],
			},
			{
				sectionName: "Daily Word Games",
				sectionEntries: [
					{
						label: "Crossword Solver",
						link: "/crosswords/",
					},
					{
						label: "Quordle Solver",
						link: "/quordle/",
					},
					{
						label: "Today's Contexto Answer",
						link: "/contexto/",
					},
				],
			},
			{
				sectionName: "Popular Games",
				sectionEntries: [
					{
						label: "4 Pics 1 Word Answers",
						link: "/4pics1word/",
					},
					{
						label: "Jumble Solver",
						link: "/jumble-solver/",
					},
					{
						label: "Word Wars Cheat",
						link: "/word-wars/",
					},
					{
						label: "Word Connect Answers",
						link: "/word-connect-answers/",
					},
					{
						label: "Word Chums Cheat",
						link: "/word-chums-cheat/",
					},
					{
						label: "Word Cookies! Cheat",
						link: "/word-cookies/",
					},
					{
						label: "All Word Games Helpers",
						link: "/game-cheats/",
					},
				],
			},
		],
	},
	{
		label: "Word List <span class='sub-label'>Maker</span>",
		link: null,
		title: "Word List Maker",
		icon: "list.svg",
		cssClass: "has-hint",
		navLink: true,
		submenuIsOpen: false,
		submenu: [
			{
				sectionName: "Top Word Lists",
				sectionEntries: [
					{
						label: "Words that Contain",
						link: "/words-with-the-letter/",
					},
					{
						label: "Words by Length",
						link: "/letter-words/",
					},
					{
						label: "Words that Start With",
						link: "/words-that-start/",
					},
					{
						label: "Words Ending In",
						link: "/ending-with/",
					},
				],
			},
			{
				sectionName: "Popular Word Lists",
				sectionEntries: [
					{
						label: "Vowel Words",
						link: "/vowels/",
					},
					{
						label: "Words without Vowels",
						link: "/consonants/",
					},
					{
						label: "Words Ending in Ing",
						link: "/ending-in-ing/",
					},
					{
						label: "Q Words without U",
						link: "/q-no-u/",
					},
					{
						label: "Popular Word Combos",
						link: "/popular-pages/",
					},
					{
						label: "Top Searched Word Combos",
						link: "/top-searched-word-combos/",
					},
					{
						label: "Top Unscrambles",
						link: "/top-unscrambles/",
					},
				],
			},
			{
				sectionName: "Words by Length",
				sectionEntries: [
					{
						label: "4 Letter Word Finder",
						link: "/4-letter-word-finder/",
					},
					{
						label: "5 Letter Word Finder",
						link: "/5-letter-word-finder/",
					},
					{
						label: "5 Letter Words",
						link: "/letter-words/5/",
					},
					{
						label: "6 Letter Word Finder",
						link: "/6-letter-word-finder/",
					},
					{
						label: "7 Letter Word Finder",
						link: "/7-letter-word-finder/",
					},
					{
						label: "8 Letter Word Finder",
						link: "/8-letter-word-finder/",
					},
					{
						label: "All Word Lists",
						link: "/index/",
					},
				],
			},
		],
	},
	{
		label: "Blog",
		link: "/blog/",
		icon: "blog.svg",
		isNew: false,
		mobileOnly: true,
		useRouter: true,
	},
	{
		label: "Our Brands",
		link: null,
		icon: "brands.svg",
		cssClass: "has-hint",
		navLink: true,
		submenuIsOpen: false,
		mobileOnly: true,
		otherSites: true,
		submenu: [
			{
				sectionEntries: [
					{
						label: "Wordscapes Answers & Cheat",
						logo: "/static/images/ic_ft_ws.png",
						logoWidth: 26,
						logoHeight: 26,
						link: "https://wordscapes.yourdictionary.com",
					},
					{
						label: "Crossword Helper",
						logo: "/static/images/ic_ft_cwh.png",
						logoWidth: 26,
						logoHeight: 26,
						link: "https://crosswordhelper.com/",
					},
					{
						label: "WordList Finder",
						logo: "/static/images/ic_ft_wlf.png",
						logoWidth: 26,
						logoHeight: 26,
						link: "https://wordlistfinder.com/",
					},
					{
						label: "Simply Scrabble",
						logo: "/static/images/ic_ft_sis.png",
						logoWidth: 26,
						logoHeight: 26,
						link: "https://simplyscrabble.com/",
					},
					{
						label: "Buscador de Palabras",
						logo: "/static/images/ic_wfw_header.png",
						logoWidth: 32,
						logoHeight: 20,
						link: "https://es.yourdictionary.com/buscador-de-palabras/",
					},
					{
						label: "YourDictionary",
						logo: "/static/images/ic_ft_yd.png",
						logoWidth: 26,
						logoHeight: 26,
						link: "https://www.yourdictionary.com/",
					},
				],
			},
		],
	},
];
